<!--Add to Cart Button-->
@if (!checked) {
  <button
    mat-icon-button
    aria-label="Add to cart"
    (click)="emitBtnClick()"
    class="add-to-cart"
    [disabled]="disabled"
    >
    <mat-icon
      #addTooltip="matTooltip"
      color="primary"
      [ngClass]="{ 'icon-disabled': disabled }"
      [matTooltip]="getTooltip()"
      (mouseleave)="addTooltip.toggle()"
      [svgIcon]="'assign_plus_icon'"
    ></mat-icon>
  </button>
}

<!--Remove from Cart Button-->
@if (checked) {
  <button
    #removeTooltip="matTooltip"
    mat-icon-button
    aria-label="Remove from cart"
    matTooltip="Remove from cart"
    (click)="emitBtnClick()"
    (mouseleave)="removeTooltip.toggle()"
    class="remove-from-cart"
    [disabled]="disabled"
    >
    <mat-icon color="warn" [svgIcon]="'assign_minus_icon'"></mat-icon>
  </button>
}
